import { cn } from '@/utils/cn';

import styles from './Spinner.module.css';

export type SpinnerSize = 'sm' | 'md' | 'lg';

export interface SpinnerProps {
  size?: SpinnerSize;
  /** Announced to screen readers. Pass `''` when a visible label already says it. */
  label?: string;
  className?: string | undefined;
}

export function Spinner({ size = 'md', label = 'Loading', className }: SpinnerProps) {
  return (
    <span
      className={cn(styles.spinner, styles[size], className)}
      role="status"
      aria-label={label === '' ? undefined : label}
      aria-hidden={label === ''}
    />
  );
}
